import { render } from "./foo.vue?vue&type=template&id=5684895b&scoped=true&lang=pug"
import script from "./foo.vue?vue&type=script&setup=true&lang=js"
export * from "./foo.vue?vue&type=script&setup=true&lang=js"

import "./foo.vue?vue&type=style&index=0&id=5684895b&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5684895b"]])

export default __exports__